// Application configuration
// Move sensitive values to environment variables in production

// For Vite environment variables
declare global {
    interface ImportMeta {
        env: {
            VITE_ADMIN_EMAIL?: string;
            [key: string]: string | undefined;
        };
    }
}

export const APP_CONFIG = {
    // Admin email - can be overridden with VITE_ADMIN_EMAIL env variable
    ADMIN_EMAIL: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_ADMIN_EMAIL) || "zydrunas@kasakai.eu",

    // Default VAT rate in Lithuania
    DEFAULT_VAT_RATE: 21,

    // Default proposal validity in days
    DEFAULT_VALIDITY_DAYS: 30,

    // Max file size for logo upload (5MB)
    MAX_LOGO_SIZE_BYTES: 5 * 1024 * 1024,

    // Supported logo formats
    SUPPORTED_LOGO_FORMATS: ['image/jpeg', 'image/png', 'image/svg+xml'] as string[],
};
